import React, {Component} from 'react';
import cookie from 'react-cookies';
import axios from 'axios';
import Autocomplete from "./Autocomplete";

import '../App.css';

class Giftxchange extends Component{
	//call the constructor method
	constructor(props){
		super(props);
		
		this.state = {
			userList: [],
			userNameList: [],
			selectedUser: null,
			xchangeAmount: '',
			description: '',
			authFlag : false
		}
	}
	
	componentWillMount(){
		this.setState({
			authFlag : false
		})

		this.getUserList();
	}

	getUserList() {
		axios.get(window.$backend_url + '/getUserList')
			.then(response => {
				if ( response.status === 200 ) {
					var temp = [];
					for (var i=0; i<response.data.length; i++) {
						temp.push(response.data[i].email);
					}

					this.setState({
						userList: response.data,
						userNameList: temp
					})
				}
			})
	}
	
	submitForm = (e) => {
		e.preventDefault();
		
		if (cookie.load('cookieId') == this.state.selectedUser.id) {
			return;
		}

		const data = {
				fromUserId: cookie.load('cookieId'),
				toUserId: this.state.selectedUser.id,
				amount: this.state.xchangeAmount,
				description: this.state.description
			}

		axios.post(window.$backend_url + '/giftXchange',data)
			.then(response => {
				if(response.status == 200){
					this.props.closeGiftXchange();
				}
			})
			.catch(error => {
			})
	}

	xchangeAmountChangeHandler(e) {
		if (e.target.validity.valid) {
			this.setState({
				xchangeAmount: e.target.value
			})
		}
	}

	changeDescriptionHandler(e) {
		this.setState({
			description: e.target.value
		});
	}

	searchUser(val) {
		var filteredOptions = this.state.userList.filter(
			(user) =>
			user.email == val
		);
		
		if (filteredOptions.length) {
			this.setState({
				selectedUser: filteredOptions[0]
			})
		}
	}

	render(){
		return(			
			<div className="modal-login custom-modal giftXchange">
				<div className="modal-logo">
					<img alt="logo" src="/assets/images/logo.png" />
				</div>
				<h2 className="text-center">{this.props.dataLanguage['giftXchange']}</h2>
				<form className="gift-form">
					<div className="form-group">
						<label>{this.props.dataLanguage['username']}</label>
						<div className="user-container custom_autocomplete">
							{ this.state.userNameList ?
								<Autocomplete
									options = {this.state.userNameList}
									changeValue = {this.searchUser.bind(this)}
								/>
							: null }
						</div>
					</div>
					<div className="form-group">
						<label>{this.props.dataLanguage['xchange_amount']}</label>
						<div className="user-container xchangeAmount">
							<input type="text" pattern="[0-9]*" value={this.state.xchangeAmount} onChange={this.xchangeAmountChangeHandler.bind(this)} className="form-control" />
						</div>
					</div>
					<div className="form-group">
						<label>{this.props.dataLanguage['message']}</label>
						<textarea className="form-control" rows="5" placeholder={this.props.dataLanguage['gift_text']} value={this.state.description} onChange={this.changeDescriptionHandler.bind(this)} />
					</div>
					<button onClick = {this.submitForm} type="submit" className="btn-submit">{this.props.dataLanguage['send_gift']}</button>
				</form>
			</div>
		)
	}
}

export default Giftxchange;


// WEBPACK FOOTER //
// ./src/components/Giftxchange.js